// extracted by mini-css-extract-plugin
module.exports = {"container":"VersionPreviewDialog-module--container--1R8yW"};